"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIFileButton = _interopRequireDefault(require("UIComponents/button/UIFileButton"));

var _DropBoxButton = _interopRequireDefault(require("FileManagerLib/components/browser/DropBoxButton"));

var _GoogleDriveButton = _interopRequireDefault(require("FileManagerLib/components/browser/GoogleDriveButton"));

var _CanvaButton = _interopRequireDefault(require("FileManagerLib/components/browser/CanvaButton"));

var _Files = require("FileManagerLib/actions/Files");

var _Constants = require("FileManagerLib/Constants");

var _Actions = require("FileManagerLib/actions/Actions");

var _Canva = require("FileManagerCore/actions/Canva");

var _Dropbox = require("FileManagerCore/actions/Dropbox");

var _GoogleDrive = require("FileManagerCore/actions/GoogleDrive");

var _Limits = require("FileManagerCore/selectors/Limits");

var _Panel = require("FileManagerLib/selectors/Panel");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _network = require("FileManagerLib/utils/network");

var _Auth = require("FileManagerCore/selectors/Auth");

function getVideoLimitI18nKey(suffix) {
  return "FileManagerLib.videoLimit.uploadVideosDisabledTooltip." + suffix;
}

var Footer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Footer, _Component);

  function Footer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Footer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Footer).call(this, props));
    _this.state = {
      dropdownOpen: false
    };
    _this.handleUpload = _this.handleUpload.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFromUrl = _this.handleFromUrl.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUploadClick = _this.handleUploadClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCanvaImport = _this.handleCanvaImport.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDropboxImport = _this.handleDropboxImport.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoogleDriveImport = _this.handleGoogleDriveImport.bind((0, _assertThisInitialized2.default)(_this));

    if (props.dropdownClassName) {
      console.warn("Warning: Usage of the prop `dropdownClassName` should NOT be used for styling purposes. You can ignore this if you're using the className for a different purpose like namespacing.");
    }

    return _this;
  }

  (0, _createClass2.default)(Footer, [{
    key: "getButtonText",
    value: function getButtonText() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.actions.addImage');

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.actions.addVideo');

        case _Constants.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.actions.addDocument');

        default:
          return _I18n.default.text('FileManagerLib.actions.addFile');
      }
    }
  }, {
    key: "getAllowedMimeTypes",
    value: function getAllowedMimeTypes() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return ['image/*'];

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return ['video/*'];

        default:
          return [];
      }
    }
  }, {
    key: "handleCanvaImport",
    value: function handleCanvaImport(file) {
      var _this$props = this.props,
          onAcquireFromCanva = _this$props.onAcquireFromCanva,
          selectedFolder = _this$props.selectedFolder;
      onAcquireFromCanva(file, selectedFolder);
    }
  }, {
    key: "handleDropboxImport",
    value: function handleDropboxImport(file) {
      var _this$props2 = this.props,
          onAcquireFromDropbox = _this$props2.onAcquireFromDropbox,
          selectedFolder = _this$props2.selectedFolder;
      onAcquireFromDropbox(file, selectedFolder);
    }
  }, {
    key: "handleGoogleDriveImport",
    value: function handleGoogleDriveImport(file) {
      var _this$props3 = this.props,
          onAcquireFromDrive = _this$props3.onAcquireFromDrive,
          selectedFolder = _this$props3.selectedFolder;
      onAcquireFromDrive(file, selectedFolder);
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange(event) {
      this.setState({
        dropdownOpen: event.target.value
      });
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(event) {
      var _this$props4 = this.props,
          selectedFolder = _this$props4.selectedFolder,
          onUploadFiles = _this$props4.onUploadFiles,
          type = _this$props4.type,
          activePanel = _this$props4.activePanel,
          onSetPanel = _this$props4.onSetPanel;
      var files = event.target.files;

      if (!files || files.length === 0) {
        return;
      }

      onUploadFiles(files, selectedFolder, type);

      if (activePanel === _Constants.Panels.FROM_URL || activePanel === _Constants.Panels.SEARCH) {
        onSetPanel(_Constants.Panels.BROWSE);
      }
    }
  }, {
    key: "handleUploadClick",
    value: function handleUploadClick() {
      this._file.click();
    }
  }, {
    key: "handleFromUrl",
    value: function handleFromUrl() {
      var onSetPanel = this.props.onSetPanel;
      onSetPanel(_Constants.Panels.FROM_URL);
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this2 = this;

      var dropdownOpen = this.state.dropdownOpen;
      var _this$props5 = this.props,
          type = _this$props5.type,
          dropdownClassName = _this$props5.dropdownClassName;
      return _react.default.createElement("div", null, _react.default.createElement("input", {
        className: "hidden",
        ref: function ref(_ref) {
          _this2._file = _ref;
        },
        type: "file",
        accept: this.getAllowedMimeTypes(),
        multiple: true,
        onChange: this.handleUpload
      }), _react.default.createElement(_UIDropdown.default, {
        open: dropdownOpen,
        buttonUse: "tertiary-light",
        buttonText: this.getButtonText(),
        onOpenChange: this.handleOpenChange,
        dropdownClassName: dropdownClassName
      }, _react.default.createElement(_UIList.default, null, _react.default.createElement(_UILink.default, {
        onClick: this.handleUploadClick
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-2",
        name: "upload"
      }), _I18n.default.text('FileManagerCore.actions.uploadFiles')), type === _Constants.DrawerTypes.IMAGE && _react.default.createElement(_UILink.default, {
        onClick: this.handleFromUrl
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-2",
        name: "link"
      }), _I18n.default.text('FileManagerLib.actions.addFromUrl')), _react.default.createElement(_DropBoxButton.default, {
        useMultiSelect: true,
        importFile: this.handleDropboxImport,
        type: type
      }), _react.default.createElement(_GoogleDriveButton.default, {
        useMultiSelect: true,
        importFile: this.handleGoogleDriveImport,
        type: type,
        googleDriveOrigin: this.props.googleDriveOrigin
      }))));
    }
  }, {
    key: "renderDisabledVideoButtonTooltip",
    value: function renderDisabledVideoButtonTooltip(button, limit) {
      return _react.default.createElement(_UITooltip.default, {
        placement: "top",
        title: _react.default.createElement(_FormattedReactMessage.default, {
          message: getVideoLimitI18nKey('message'),
          options: {
            limit: limit,
            filesLink: _react.default.createElement(_UILink.default, {
              href: (0, _network.getRedirectToFilesLocation)(),
              key: "link-to-files"
            }, _react.default.createElement(_FormattedMessage.default, {
              message: getVideoLimitI18nKey('filesLink')
            }))
          }
        })
      }, button);
    }
  }, {
    key: "renderUploadVideoButton",
    value: function renderUploadVideoButton() {
      var _this$props6 = this.props,
          hasUserExceededVideoLimit = _this$props6.hasUserExceededVideoLimit,
          videoLimit = _this$props6.videoLimit,
          type = _this$props6.type;

      var button = _react.default.createElement(_UIFileButton.default, {
        use: "tertiary-light",
        size: "small",
        disabled: hasUserExceededVideoLimit,
        accept: this.getAllowedMimeTypes(),
        multiple: true,
        onChange: this.handleUpload
      }, _I18n.default.text('FileManagerCore.actions.uploadVideos'));

      if (type === _Constants.DrawerTypes.HUBL_VIDEO && hasUserExceededVideoLimit) {
        return this.renderDisabledVideoButtonTooltip(button, videoLimit);
      }

      return button;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          isUngatedForCanva = _this$props7.isUngatedForCanva,
          type = _this$props7.type;

      if (type === _Constants.DrawerTypes.VIDEO || type === _Constants.DrawerTypes.HUBL_VIDEO) {
        return this.renderUploadVideoButton();
      }

      return _react.default.createElement("div", {
        className: "flex-row"
      }, this.renderDropdown(), isUngatedForCanva && _react.default.createElement(_CanvaButton.default, {
        importFile: this.handleCanvaImport
      }));
    }
  }]);
  return Footer;
}(_react.Component);

Footer.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  selectedFolder: _react.PropTypes.instanceOf(_immutable.Map),
  activePanel: _react.PropTypes.oneOf(Object.keys(_Constants.Panels)).isRequired,
  onSetPanel: _react.PropTypes.func.isRequired,
  onUploadFiles: _react.PropTypes.func.isRequired,
  onAcquireFromCanva: _react.PropTypes.func.isRequired,
  onAcquireFromDropbox: _react.PropTypes.func.isRequired,
  onAcquireFromDrive: _react.PropTypes.func.isRequired,
  hasUserExceededVideoLimit: _react.PropTypes.bool.isRequired,
  isUngatedForCanva: _react.PropTypes.bool.isRequired,
  videoLimit: _react.PropTypes.number.isRequired,
  googleDriveOrigin: _react.PropTypes.string,
  dropdownClassName: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    activePanel: (0, _Panel.getActivePanel)(state),
    hasUserExceededVideoLimit: (0, _Limits.getHasUserExceededEmbeddableVideoLimit)(state),
    isUngatedForCanva: (0, _Auth.getIsUngatedForCanva)(state),
    videoLimit: (0, _Limits.getEmbeddableVideoLimit)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUploadFiles: function onUploadFiles(files, folder, type) {
      var options = {
        type: type
      };

      if (folder && folder.get('id')) {
        options.folderId = folder.get('id');
      }

      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'upload'));
    },
    onSetPanel: function onSetPanel(activePanel) {
      dispatch((0, _Actions.setPanel)({
        activePanel: activePanel
      }));
    },
    onAcquireFromCanva: function onAcquireFromCanva(file, folder) {
      dispatch((0, _Canva.acquireFileFromCanva)(file, folder));
    },
    onAcquireFromDropbox: function onAcquireFromDropbox(file, folder) {
      dispatch((0, _Dropbox.acquireFileFromDropbox)(file, folder));
    },
    onAcquireFromDrive: function onAcquireFromDrive(file, folder) {
      dispatch((0, _GoogleDrive.acquireFileFromDrive)(file, folder));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Footer);

exports.default = _default;
module.exports = exports.default;